import MobileMenuContext from "@/contexts/MobileMenuContext";
import { useContext } from "react";

export const useMobileMenuToggle = () => {
 return useContext(MobileMenuContext);
};
